<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>

    <div v-if="editedItem.assignAgentMemberInfo">
      <v-layout row class="mt-1">
        <v-flex xs12>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout class="mx-0 px-0 mb-4">
              <v-flex xs12 sm2 style="border-bottom: 1px dotted gray;" class="mr-4">ID</v-flex>
              <v-flex xs12 sm3 style="border-bottom: 1px dotted gray;" class="mr-4">Name</v-flex>
              <v-flex xs12 sm3 style="border-bottom: 1px dotted gray;" class="mr-4">Group ID</v-flex>
              <v-flex xs12 sm4 style="border-bottom: 1px dotted gray;" class="">Number of Allowed Task</v-flex>
            </v-layout>
            
              <v-layout class="mx-0 px-0"
                
                v-for="(element, index) in editedItem.assignAgentMemberInfo"
                :key="index"
              >
                <v-flex xs12 sm2 class="mr-4">
                  <!-- <v-text-field class="my-0 py-0"
                    v-model="editedItem.assignAgentMemberInfo[index].dasher_id"
                    disabled
                    height="14"
                  ></v-text-field> -->
                  <p style="border-bottom: 1px dotted gray;">{{ index+1 }}</p>
                </v-flex>
                <v-flex xs12 sm3 class="mr-4">
                  <!-- <v-text-field class="my-0 py-0"
                    v-model="editedItem.assignAgentMemberInfo[index].name"
                    disabled
                    height="14"
                  ></v-text-field> -->
                  <p style="border-bottom: 1px dotted gray;">{{ editedItem.assignAgentMemberInfo[index].name }}</p>
                </v-flex>
                <v-flex xs12 sm3 class="mr-4">
                  <!-- <v-text-field class="my-0 py-0"
                    v-model="
                      editedItem.assignAgentMemberInfo[index].agent_group_id
                    "
                    disabled
                    height="14"
                  ></v-text-field> -->
                  <p style="border-bottom: 1px dotted gray;">{{ editedItem.assignAgentMemberInfo[index].agent_group_id }}</p>
                </v-flex>
                <v-flex xs12 sm4 class="">
                  <v-text-field class="my-0 py-0"
                    numeric
                    v-model="
                      editedItem.assignAgentMemberInfo[index]
                        .number_of_allowed_task
                    "
                    :rules="allowedTaskRules"
                    @keypress="isDigit($event)"
                    height="20"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            <v-divider></v-divider>
            <v-card-actions>
              <button class="button" flat @click="back">Back</button>
              <v-spacer></v-spacer>
              <v-btn class="button" flat @click="save">Save</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import router from "@/router";
import api from "@/api/datadash";
export default {
  props:{
    agent_group_id: Number,
  },
  data: () => ({
    valid: true,
    dialog: false,
    search: "",
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    apiUrl: "agent.group-members-info",
    responseData: {},
    editedIndex: -1,
    previousData: [],
    editedItem: {
      project_id: null,
      assignAgentMemberInfo: [],
    },
    defaultItem: {
      project_id: null,
      assignAgentMemberInfo: [],
    },
    allowedTaskRules: [(v) => !!v || "This field is required"],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.getAgentListData();
  },

  methods: {
    initialize() {
      this.editItem.project_id = this.$route.params.id;
    },

    async getAgentListData() {
      try {
        const token = window.localStorage.getItem("datadash_token");
        // console.log(this.agent_group_id);
        if (token != null) {
          let response = await api.fetchAllData(
            token,
            "agent.group-members-info",
            this.$route.params.id+"/"+this.agent_group_id
          );
          this.responseData = response.data.data;
          this.editedItem.assignAgentMemberInfo =
            this.responseData.agentGroupMemberInfo;
          this.initialize();
        }
      } catch (error) {
        // console.log(error);
      }
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      this.editedIndex = this.indexData.urlToRoles.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    isDigit(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[0-9]+$/.test(char)) return false;
      // Match with regex
      else {
        this.digitValidate = true;
        e.preventDefault();
      } // If not match, don't add to input text
    },

    deleteItem(item) {
      const index = this.indexData.urlToRoles.indexOf(item);
      var result =
        confirm("Are you sure you want to delete this item?") &&
        this.indexData.urlToRoles.splice(index, 1);
      if (result) {
        this.$store.dispatch("delete", [this.apiUrl, item.id]);
        this.initialize();
      }
    },
    back() {
      localStorage.setItem("EditBudgetObject", JSON.stringify(this.budget));

      router.push("/dynamic-question");
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    needAssistant() {
      this.dialog = true;
      // this.snackbar = true;
      // this.close();
    },
    onClickAssistant(event) {
      if (event == 1) {
        this.dialog = false;
        this.snackbar = true;
        this.close;
      } else {
        this.dialog = false;
      }
    },

    save() {
      if (this.$refs.form.validate()) {
        // console.log(this.editedItem.assignAgentMemberInfo);
        this.$store.dispatch("storeOrUpdateProjectAgentTaskDefine", [
          "define.project.task.to-agent",
          this.editedItem.assignAgentMemberInfo,
        ]);
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>
<style scoped>
.tbl-border {
  border: 1px solid #000;
}
.table-th {
  border: 1px solid #000;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
.no-upercase {
  text-transform: unset !important;
}
</style>
